<template>
  <t-content>
    <t-container class="info-and-help">
      <t-toggle-box
        @toggle="toggleListener"
        :title="$t('infoAndHelp.main.title')"
        :qe-id="`tournament-faq-${zoneId}`"
        :open="true"
      >
        <div class="collapsible-wrap">
          <t-collapsible-list v-if="textZone" :html-text="textZone" clickTag="h2" @action="clickHandler" />
          <t-collapsible-list :html-text="text" clickTag="h2" @action="clickHandler" />
        </div>
        <template v-slot:bottom>
          <c-customer-service
            class="customer-service"
            @customer="onCustomer"
            :text="$t('infoAndHelp.main.customerService')"
          ></c-customer-service>
        </template>
      </t-toggle-box>
    </t-container>
  </t-content>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import { marked } from 'marked'
import CCustomerService from '@/components/CCustomerService.vue'
import { Getters } from '@/store/getters'

const store = useStore()
const { t } = useI18n()

const text = computed(() => {
  if (store.state.zone.gametype)
    return marked(
      t('infoAndHelp.main.collapsible_md', {
        gameName: t('generic.game.name_' + store.state.zone.gametype),
      })
    )
  else return ''
})
const textZone = computed(() => {
  if (zoneId.value && store.state.zone.gametype) {
    const text: string = t('infoAndHelp.main.' + zoneId.value, {
      gameName: t('generic.game.name_' + store.state.zone.gametype),
    }) as string
    return text && !/infoAndHelp\.main/.test(text) ? marked(text) : ''
  }
  return ''
})

const zoneId = computed(() => {
  return (store.getters as Getters).tournamentUi.zoneId
})

function toggleListener() {
  // console.log('Nothing tracked')
}

function onCustomer() {
  events.$emit('cs-form')
}

function clickHandler(e: Event) {
  const event: any = e
  if (event.target && event.target.tagName === 'A' && event.target.href) {
    if (/#gamerules/.test(event.target.href)) {
      events.$emit('game-rules', { gametype: store.state.zone.gametype })
    } else if (/#customerservice/.test(event.target.href)) {
      // ? this do not exists anymore
      const win: any = window.open('/gd/support/contact.xhtml', 'customer')
      win.focus()
    }
  }
  e.preventDefault()
}
/**
 * load game rules JS - there was no way to include them in the index.html after
 * the phonitaire-web - and the game rules needs the Vue instance from phonitaire-web
 */
function loadGameRules() {
  // make sure to load it only once
  if (!store.state.gameRulesLoaded) {
    store.commit('gameRulesLoaded', true)
    var script = document.createElement('script')
    script.src = '../game-rules-web/index.js'
    script.type = 'module'
    document.head.appendChild(script)
  }
}
loadGameRules()
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.info-and-help {
  margin: 6em auto 0;
  h2 {
    // margin: 0;
  }
  .customer-service {
    margin: 0 !important;
    border-radius: 0 !important;
    border-top: 0 !important;
  }
  .collapsible-wrap {
    margin-bottom: 2.5em;
  }
}
</style>
